import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { nextTick } from "vue";

export const func = {
  async showQuestionAlert(text, callback) {
    return new Promise((resolve) => {
      let alert;
      Swal.fire({
        target: "#custom-target-swal2",
        html: text,
        icon: "question",
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        allowOutsideClick: false,
        returnFocus: false,
        focusConfirm: true,
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didRender: () => {
          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          const popup = document.querySelector(".swal2-popup");
          popup.addEventListener("keydown", this.handleEventKey);
          document.addEventListener("keydown", this.handleEventKey);
        },
        willClose: () => {
          const popup = document.querySelector(".swal2-popup");
          popup.removeEventListener("keydown", this.handleEventKey);
          document.removeEventListener("keydown", this.handleEventKey);
        },
        didClose: async () => {
          await nextTick();
          if (callback) {
            await callback(alert);
          }

          resolve(alert);
        },
      }).then((result) => {
        alert = result;
      });
    });
  },

  async showInvalidAlert(text, callback) {
    return new Promise((resolve) => {
      let alert;
      Swal.fire({
        target: "#custom-target-swal2",
        html: text,
        icon: "warning",
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        allowOutsideClick: false,
        returnFocus: false,
        focusConfirm: true,
        buttonsStyling: false,
        confirmButtonText: "ENTER - OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didRender: () => {
          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          const popup = document.querySelector(".swal2-popup");
          popup.addEventListener("keydown", this.handleEventKey);
          document.addEventListener("keydown", this.handleEventKey);
        },
        willClose: () => {
          const popup = document.querySelector(".swal2-popup");
          popup.removeEventListener("keydown", this.handleEventKey);
          document.removeEventListener("keydown", this.handleEventKey);
        },
        didClose: async () => {
          await nextTick();
          if (callback) {
            await callback(alert);
          }

          resolve(alert);
        },
      }).then((result) => {
        alert = result;
      });
    });
  },

  async showErrorAlert(text, callback) {
    return new Promise((resolve) => {
      let alert;
      Swal.fire({
        target: "#custom-target-swal2",
        html: text,
        icon: "error",
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        allowOutsideClick: false,
        returnFocus: false,
        focusConfirm: true,
        buttonsStyling: false,
        confirmButtonText: "ENTER - OK",
        customClass: {
          confirmButton: "btn fw-bold btn-danger",
        },
        didRender: () => {
          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          const popup = document.querySelector(".swal2-popup");
          popup.addEventListener("keydown", this.handleEventKey);
          document.addEventListener("keydown", this.handleEventKey);
        },
        willClose: () => {
          const popup = document.querySelector(".swal2-popup");
          popup.removeEventListener("keydown", this.handleEventKey);
          document.removeEventListener("keydown", this.handleEventKey);
        },
        didClose: async () => {
          await nextTick();
          if (callback) {
            await callback(alert);
          }

          resolve(alert);
        },
      }).then((result) => {
        alert = result;
      });
    });
  },

  async showInfoAlert(text, callback) {
    return new Promise((resolve) => {
      let alert;
      Swal.fire({
        target: "#custom-target-swal2",
        html: text,
        icon: "info",
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        allowOutsideClick: false,
        returnFocus: false,
        focusConfirm: true,
        buttonsStyling: false,
        confirmButtonText: "ENTER - OK",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
        },
        didRender: () => {
          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          const popup = document.querySelector(".swal2-popup");
          popup.addEventListener("keydown", this.handleEventKey);
          document.addEventListener("keydown", this.handleEventKey);
        },
        willClose: () => {
          const popup = document.querySelector(".swal2-popup");
          popup.removeEventListener("keydown", this.handleEventKey);
          document.removeEventListener("keydown", this.handleEventKey);
        },
        didClose: async () => {
          await nextTick();
          if (callback) {
            await callback(alert);
          }

          resolve(alert);
        },
      }).then((result) => {
        alert = result;
      });
    });
  },

  async showSuccessAlert(text, callback) {
    return new Promise((resolve) => {
      let alert;
      Swal.fire({
        target: "#custom-target-swal2",
        html: text,
        icon: "success",
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        allowOutsideClick: false,
        returnFocus: false,
        focusConfirm: true,
        buttonsStyling: false,
        confirmButtonText: "ENTER - OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didRender: () => {
          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          const popup = document.querySelector(".swal2-popup");
          popup.addEventListener("keydown", this.handleEventKey);
          document.addEventListener("keydown", this.handleEventKey);
        },
        willClose: () => {
          const popup = document.querySelector(".swal2-popup");
          popup.removeEventListener("keydown", this.handleEventKey);
          document.removeEventListener("keydown", this.handleEventKey);
        },
        didClose: async () => {
          await nextTick();
          if (callback) {
            await callback(alert);
          }

          resolve(alert);
        },
      }).then((result) => {
        alert = result;
      });
    });
  },

  async showCustomAlert(text, icon, btnOk, btnCancel, callback) {
    return new Promise((resolve) => {
      let alert;
      Swal.fire({
        target: "#custom-target-swal2",
        html: text,
        icon: icon,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        allowOutsideClick: false,
        returnFocus: false,
        focusConfirm: true,
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: btnOk,
        cancelButtonText: btnCancel,
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didRender: () => {
          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          const popup = document.querySelector(".swal2-popup");
          popup.addEventListener("keydown", this.handleEventKey);
          document.addEventListener("keydown", this.handleEventKey);
        },
        willClose: () => {
          const popup = document.querySelector(".swal2-popup");
          popup.removeEventListener("keydown", this.handleEventKey);
          document.removeEventListener("keydown", this.handleEventKey);
        },
        didClose: async () => {
          await nextTick();
          if (callback) {
            await callback(alert);
          }

          resolve(alert);
        },
      }).then((result) => {
        alert = result;
      });
    });
  },

  handleEventKey(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      const confirmButton = document.querySelector(".swal2-confirm");
      if (confirmButton) {
        confirmButton.click();
      }
    } else if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      const cancelButton = document.querySelector(".swal2-cancel");
      if (cancelButton) {
        cancelButton.click();
      }
    }
  },
};

export default func;
